module.exports = __webpack_public_path__ + "img/longitud.e9ebb928.png";